import React from "react";
import { inject, observer } from "mobx-react";
import { AuthStore, LogStore, UserStore } from "src/stores";
import { LogEntry } from "./logEntry";

export interface IActivityLogProps {
  authStore?: AuthStore;
  userStore?: UserStore;
  logStore?: LogStore;
}

// TODO: Create log components for global activity log as well.

export const ActivityLog = inject(
  "authStore",
  "userStore",
  "logStore"
)(
  observer((props: IActivityLogProps): JSX.Element => {
    const sortedEvents = React.useMemo(
      () => props.logStore.getItems.sort((a, b) => b.id - a.id),
      [props.logStore.getItems]
    );

    return (
      <>
        {sortedEvents.map((item) => (
          <LogEntry
            key      = {item.id}
            user     = {props.userStore.getItemByID(item.user_id)}   // TODO: Handle missing user
            log      = {item}
            item     = {props.logStore.rootStore.getActiveItem}
            itemType = {props.logStore.rootStore.getActiveItemType}
          />
        ))}
      </>
    );
  })
);

